import "./App.css";

import GlobalStyles from "./assets/styles/globalStyle";
import Routes from "./router";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

function App() {
  return (
    <Provider store={store}>
      <ReactNotifications />
      <GlobalStyles />
      <Routes />
    </Provider>
  );
}

export default App;
